import { FieldMappingContainer } from "packages/contentful";
import { MobileDeviceValues } from "packages/smart-setup-core";
import { FactoryTypes, FieldID, GuideContent } from "../../../models";

export const backupAndroidContent = (
  oldPhone: MobileDeviceValues,
  additionalSteps?: FieldMappingContainer<GuideContent>[],
) => ({
  criteria: { oldPhone },
  content: [
    {
      type: FactoryTypes.TIPBOX,
      fieldMapping: {
        text: FieldID.guideContainer.tipBox.makeSureConnectedToWifi,
        icon: FieldID.guideContainer.tipBox.icon,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.openGoogleDriveStep.text,
        image: FieldID.guideContainer.steps.openGoogleDriveStep.image,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.backupAndResetSamsungStep.text,
      },
    },
    {
      type: FactoryTypes.IMAGE_CAROUSEL,
      fieldMapping: {
        images: FieldID.guideContainer.steps.backupAndResetSamsungStep.images,
      },
    },
    {
      type: FactoryTypes.NUMBERED_STEP,
      fieldMapping: {
        text: FieldID.guideContainer.steps.selectBackupNowStep.text,
        image: FieldID.guideContainer.steps.selectBackupNowStep.image,
      },
    },
    ...(additionalSteps || []),
    {
      type: FactoryTypes.EXPERT_HELP,
      fieldMapping: {
        buttonText: FieldID.guideContainer.expertHelpContent.buttonText,
        title: FieldID.guideContainer.expertHelpContent.title,
        subtext: FieldID.guideContainer.expertHelpContent.subtext,
        secondaryButtonText:
          FieldID.guideContainer.expertHelpContent.secondaryButtonText,
        icon: FieldID.guideContainer.expertHelpContent.icon,
        supportNumber: FieldID.guideContainer.expertHelpContent.supportNumber,
      },
    },
  ],
});
